<template>
  <div>
    <div v-show="errorMessage" class="uk-alert-danger" uk-alert>
      <p>{{ errorMessage }}</p>
    </div>
    <form @submit.prevent="submit"
          class="uk-form-stacked"
          id="mbk_form">
      <fieldset class="uk-fieldset">
        <label class="uk-form-label">{{ $t("repay.birthday") }}</label>
        <datepicker v-model="form.dateofbirth"></datepicker>
        <small class="uk-text-danger" v-html="form.flattenErrors('dateofbirth')"></small>
      </fieldset>

      <fieldset class="uk-fieldset">
        <label for="account" class="uk-form-label">{{ $t("repay.account") }}</label>
        <div class="uk-form-controls uk-grid-small" uk-grid>
          <div class="uk-inline uk-width-expand">
            <input id="account"
                   @input="setAccount"
                   :value="form.account"
                   type="text"
                   inputmode="numeric"
                   class="uk-input">
          </div>
          <div class="uk-width-auto uk-margin-auto-vertical">
            <a href="#recover_account_text" uk-toggle>{{ $t("repay.forgot") }}</a>
          </div>
        </div>
        <small class="uk-text-danger" v-html="form.flattenErrors('account')"></small>
      </fieldset>
      <fieldset class="uk-fieldset">
        <button type="submit" class="uk-button uk-button-primary uk-width-1-1">
          {{ buttonCaption }}
          <span v-if="processing" uk-spinner="ratio: 0.75"></span>
        </button>
      </fieldset>
    </form>

    <div id="recover_account_text" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2>{{ $t('repay.modal.header') }}</h2>
        <p>{{ $t('repay.modal.p1') }}</p>
        <p>{{ $t('repay.modal.p2') }}</p>
        <p>{{ $t('repay.modal.p3') }}</p>
        <p class="uk-text-right">
          <button class="uk-button mbk_button_blue uk-modal-close" type="button">{{ $t('close') }}</button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { RepayForm }                from "@/utils/RepayForm";
import Datepicker                   from "@/components/Datepicker";

export default {
  name: "RepayForm",
  components: {
    Datepicker
  },
  created() {
    this.form = new RepayForm(
        this.repay.account,
        this.repay.dateofbirth
    );
  },
  data() {
    return {
      form: new RepayForm(),
      processing: false,
      errorMessage: ""
    };
  },
  methods: {
    ...mapMutations(["setRepay"]),
    // These duplications implemented because when you call directly
    // the methods themselves they will lose `this` context
    setAccount(e) {
      this.form.setAccount(e);
    },
    submit() {
      this.form.validate();
      if (!this.form.isValid || this.processing) return;
      this.processing = true;
      this.$http.post("/repay-ru/", this.form.serialize())
          .then(res => {
            this.setRepay({
              ...res.data,
              account: this.form.account,
              dateofbirth: this.form.dateofbirth
            });
            this.$parent.done();
          })
          .catch(err => {
            if (err.response.status === 400) {
              this.errorMessage = err.response.data.message;
            }
          }).then(() => this.processing = false);
    }
  },
  computed: {
    ...mapGetters(["repay"]),
    buttonCaption() {
      if (this.processing) {
        return "";
      }
      return this.$t("credit_card.check");
    }
  }
};
</script>